<p class="m-0"><strong>Saņēmējs(i): </strong>{{ notificationHistory.toRecipients }}</p>
@if (notificationHistory.ccRecipients) {
    <p class="m-0"><strong>Cc: </strong>{{ notificationHistory.ccRecipients }}</p>
}

@if (notificationHistory.bccRecipients) {
    <p class="m-0"><strong>Bcc: </strong>{{ notificationHistory.bccRecipients }}</p>
}

<h3>Saturs:</h3>
<iframe #emailFrame style="width: 100%; height: 25rem; border: none" sandbox="allow-same-origin" [srcdoc]="notificationHistory.contentsHtml | safeHtml"></iframe>
